// extracted by mini-css-extract-plugin
export default {"location":"locations_location__vnshA","location__lists":"locations_location__lists__ZfPPx","column":"locations_column__khb4s"};